<template>
  <div class="bg-gray-200 animate-pulse rounded" />
</template>
